<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ title }}</div>
    <div slot="body">
      <a-alert :message="message" banner />
      <dialog-selected-tips :name="$t('bill.text_210')" class="mt-3" :count="params.data.length" :action="title" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import i18n from '@/locales'

export default {
  name: 'RuleSetDisabledDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    title () {
      if (this.params.isEnabled) {
        return i18n.t('bill.text_194')
      } else {
        return i18n.t('bill.text_196')
      }
    },
    message () {
      if (this.params.isEnabled) {
        return i18n.t('bill.confirm_enable_rule')
      } else {
        return i18n.t('bill.text_209')
      }
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const ids = this.params.data.map(item => item.id)
        var action = 'disable'
        if (this.params.isEnabled) {
          action = 'enable'
        }
        await this.params.onManager('batchPerformAction', {
          id: ids,
          managerArgs: {
            action: action,
          },
        })
        this.cancelDialog()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
